<template>
  <div class="result-body" :style="styles">
    <div class="prioritized-list">
            
      <div class="prioritized-inner">
        
        <span class="birthdate">{{birthStr}}</span>
        <h3 class="result-body--h3" v-html="titleStrMod"></h3>
        <div
          class="list-item"
          v-for="(item, idx) in prioritizedList"
          :key="`p${idx}`"
        >
          <div class="img-area" :class="{ 'is-same' : isSame }" >
            <img :src="item.image" alt="" class="item-img">
            <img :src="item.image" alt="" v-if="isSame" class="item-img">
          </div>
          <span class="headline" v-html="item.name"></span>
          <p class="description" v-html="item.text"></p>
        </div>
       </div> 
    </div>
    <div class="sub-list">
      <div
        class="list-item"
        v-for="(item, idx) in subList"
        :key="`p${idx}`"
      >
        <img :src="item.image" alt="" class="item-img">
        <span class="headline" v-html="item.name"></span>
        <p class="description" v-html="item.text"></p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ResultBakuroNumB',
  components: {},
  props: {
    titleStr: {
      type: String,
      required: true,
    },
    birthStr: {
      type: String,
      required: true,
    },
    resultData: {
      type: Object,
      //type: [Object, Array],
      required: true,
    },
  },
  data(){
    return {
      subList: [],
    }
  },
  computed: {
    isSame() {
      return this.resultData.result1.unsei ===  this.resultData.result2.unsei
      //return true
    },
    titleStrMod(){
      if(this.prioritizedList.length > 1 && this.priorityList.length > 1)
        return this.titleStr.replace('__num__',
          `${this.prioritizedList[0].unsei}・${this.prioritizedList[1].unsei}`)
      return this.titleStr.replace('__num__', this.prioritizedList[0].unsei)
    },
    originalList(){
      return [
        this.resultData.result1,
        this.resultData.result2,
      ]
    },
    priorityList(){
      const formula = /^\[\d*(?:,\d*)*\]$/.test(this.resultData.summary) ? this.resultData.summary : null
      return !!formula ? eval(formula) : []
      //return [this.originalList[0].unsei,this.originalList[1].unsei] 
    },
    prioritizedList(){
      const rtn = []
      this.originalList.forEach(resData => {
        let added = false
        this.priorityList.forEach( item => {
          if(+resData.unsei === item) {
            added = true
            rtn.push(resData)
          }
        })
        if(!added) this.subList.push(resData)
      })
      return this.isSame ? [rtn[0]] : rtn
    },

    styles(){
      return {}
    },
  },
  created() {},
  mounted() {
    console.log('受け取った結果データ:%O priorityList', this.resultData, this.priorityList)
    console.log('生成する prioritizedList%O subList%O', this.prioritizedList, this.subList)
    //console.log(this.isSame)
  },
  methods: {},
}</script>

<style scoped lang='scss'>
@import "../../../../../../sass/commons/commonVariables.scss";
@import "../../../../../../sass/commons/styles/fonts";

$title-fontfamily:'Hiragino Mincho Pro';
$main-green:#00462E;
$uranai-black: #32373F;
$houen-blue:#3A89C9;
.products-result-base {
  .result-base {
    .result-body {
      background: #F9F5ED;
      padding:0 20px;
      .prioritized-list{
        background: #fff;
        border: 1px solid $main-green;
        position: relative;
        margin-bottom: 30px;
        &:before{
          content: "";
          position: absolute;
          width: 99%;
          height: 9px;
          top: 3px;
          left: 4px;
          background: url(/static/img/recommend/lp/houen/products/result_frame.svg) repeat-x;
        }
        &:after{
          content: "";
          position: absolute;
          width: 99%;
          height: 9px;
          bottom: 3px;
          left: 4px;
          background: url(/static/img/recommend/lp/houen/products/result_frame.svg) repeat-x;
        }
        .prioritized-inner{
          border-left: 1px dashed $main-green;
          border-right: 1px dashed $main-green;
          margin: 19px 8px 24px;
          padding: 12px 12px;
          .list-item{
            margin-bottom: 40px;
            &:nth-child(2n){
              margin-bottom: 0;
            }
          }
          .headline{
            //font-family: 'Hiragino Kaku Gothic Pro';
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;
            color: $main-green;
            display: block;
            position: relative;
            padding: 13px 10px 16px;
            max-width: 300px;
            margin:auto;
            margin-bottom: 16px;
            &::before{
              content:'';
              background: url('/static/img/recommend/lp/houen/products/headline_top.svg');
              position: absolute;
              width: 100%;
              background-repeat: no-repeat;
              height: 12px;
              top: 0;
              left: 0;
            }
            &:after{
              content:'';
              background: url('/static/img/recommend/lp/houen/products/headline_bottom.svg');
              position: absolute;
              width: 100%;
              background-repeat: no-repeat;
              height: 12px;
              left: 0;
              bottom: 0;
            }
          }
          .description{
            margin:0;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
          }
        }
        .result-frameline-top{
          position: absolute;
          top: 3px;
          left: 3px;
        }
        .result-frameline-bottom{
          position: absolute;
          bottom: 3px;
          left: 3px;
        }
        
      }
      
      .item-img{
        width:140px;
        height:140px;
        display: block;
        margin: auto;
        margin-bottom: 24px;
        border-radius:10px ;
      }
      .list-item{
       
      }
      .birthdate {}
      h3 {}
      .result-head {
        .head-item {
          transition: all 300ms ease-out 0s;
          filter: alpha(0.2);
          cursor: pointer;
          user-select: none;
          img {
            border: 1px solid blue;
            display: block;
            min-height: 30px;
          }
          &.selected {
            filter: none;
            border: 1px solid red;
          }
        }
        &.is-same {
          .head-item {
            filter: none;
            cursor: default;
            &.selected {
              border: none;
            }
          }
        }
      }

    }
  }
}

.headline{
  font-family: 'Hiragino Kaku Gothic Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: $main-green;
  display: block;
  position: relative;
  padding: 0;
  margin-bottom: 10px;
}
.sub-list {
    padding: 0 20px 40px;
}


.birthdate {
  @extend .source-han-serif-bold;
  //font-family: $title-fontfamily;
  display: block;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  color:$main-green;
  margin-bottom: 4px;
}

.result-body--h3 {
  @extend .source-han-serif-bold;
  //font-family:$title-fontfamily;
  //font-style: normal;
  //font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color:$main-green;
  margin:0;
  margin-bottom: 24px;
}

.description{
  //font-family: 'Hiragino Kaku Gothic Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: justify;
  color: $uranai-black;
  margin:0;
}
.img-area.is-same{
    display: flex;
}


</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/fortunes/ResultBakuroNumB.vue